var _defs, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayoutGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 420,
    viewBox: "0 0 600 420",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "rect-tile"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "currentColor",
    stroke: "#808080",
    strokeWidth: 2
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 50,
    y: 60
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 150,
    y: 60
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 250,
    y: 60
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 350,
    y: 60
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 450,
    y: 60
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 50,
    y: 160
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 150,
    y: 160
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 250,
    y: 160
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 350,
    y: 160
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 450,
    y: 160
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 50,
    y: 260
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 150,
    y: 260
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 250,
    y: 260
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 350,
    y: 260
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    href: "#rect-tile",
    x: 450,
    y: 260
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutGrid);
export default __webpack_public_path__ + "static/media/layout-grid.499e3807fdab9401e471291ab0c18623.svg";
export { ForwardRef as ReactComponent };